import { Directive, ElementRef, HostListener } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Directive({
    selector: '[sbiCotBackThousandsPoints]',
    standalone: false
})
export class ThousandsPointsDirective {
  constructor(
    private el: ElementRef,
    private _decimalPipe: DecimalPipe
  ) {}

  @HostListener('input')
  onInput() {
    let position = this.el.nativeElement.selectionStart;
    if (this.el.nativeElement.value === '-') return;
    const pointsRemoved = this.el.nativeElement.value.replace(/\./g, '');
    let toInt: number;
    let toLocale: string;
    if (pointsRemoved === ',') {
      this.el.nativeElement.value = '0,';
      position++;
    } else {
      if (pointsRemoved.split(',').length > 1) {
        const decimal = isNaN(parseInt(pointsRemoved.split(',')[1]))
          ? ''
          : parseInt(pointsRemoved.split(',')[1]);
        toInt = parseInt(pointsRemoved);
        toLocale = toInt.toLocaleString('es-UY') + ',' + decimal;
        const IntPart = pointsRemoved.split(',')[0];
        if ((IntPart.length - 1) % 3 === 0) {
          if (position !== 1) position++;
        }
      } else {
        toInt = parseInt(pointsRemoved);
        toLocale = toInt.toLocaleString('es-UY');
        if ((pointsRemoved.length - 1) % 3 === 0) {
          if (position !== 1) position++;
        }
      }
      if (toLocale === 'NaN') {
        this.el.nativeElement.value = '';
      } else {
        this.el.nativeElement.value = toLocale;
      }
    }

    this.el.nativeElement.selectionStart = position;
    this.el.nativeElement.selectionEnd = position;
  }
}
